"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _DateTimeHeader = _interopRequireDefault(require("./DateTimeHeader.style"));
var _Label = _interopRequireDefault(require("../../Label"));
var _dateUtils = _interopRequireDefault(require("../../utils/dateUtils"));
var _utils = _interopRequireDefault(require("../../utils/utils"));
var _dec, _class; // @ts-check
/**
 * Контейнер с отображением даты и времени
 * */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const INPUT_DEBOUNCE_DELAY = 1000;
let DateTimeHeader = (_dec = (0, _reactJss.default)(_DateTimeHeader.default), _dec(_class = class DateTimeHeader extends _react.PureComponent {
  constructor(props) {
    super(props);
    const {
      displayTime,
      unix
    } = this.props;
    const date = new Date(unix * 1000);
    const time = _dateUtils.default.correctTime(date.getHours(), date.getMinutes());
    this.state = {
      unix,
      time,
      displayTime,
      activeDateInput: false,
      dateValue: '',
      dateError: false
    };
    this.handleBlurTime = this.handleBlurTime.bind(this);
    this.handleBlurDate = this.handleBlurDate.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleInputChangeTime = this.handleInputChangeTime.bind(this);
    this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
    this.updateTimeDebounced = _utils.default.debounce(this.updateTime.bind(this), INPUT_DEBOUNCE_DELAY);
    this.parseDateEntryDebounced = _utils.default.debounce(this.parseDateEntry.bind(this), INPUT_DEBOUNCE_DELAY);
  }
  static getDerivedStateFromProps(props, state) {
    const {
      unix,
      displayTime
    } = props;
    if (unix !== state.unix || displayTime !== state.displayTime) {
      const date = new Date(unix * 1000);
      const time = _dateUtils.default.correctTime(date.getHours(), date.getMinutes());
      return {
        unix,
        time,
        displayTime
      };
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.props.onUpdate) return;
    // Check if any state field has changed
    if (prevState !== this.state) {
      this.props.onUpdate(this.state);
    }
  }
  handleBlurTime() {
    this.updateTime();
  }
  handleBlurDate() {
    const {
      dateValue
    } = this.state;
    if (!dateValue) {
      this.setState({
        activeDateInput: false,
        dateError: false
      });
    } else {
      this.parseDateEntry(dateValue);
    }
  }
  handleKeyDown(e) {
    const {
      activeDateInput
    } = this.state;
    // Check if the Enter key (keyCode 13) is pressed
    if (e.keyCode !== 13) return;
    if (activeDateInput) {
      this.handleBlurDate();
    } else {
      this.handleBlurTime();
    }
  }
  updateTime() {
    const {
      id,
      onTimeChange,
      unix
    } = this.props;
    const {
      time
    } = this.state;
    const date = new Date(unix * 1000);
    const {
      hours,
      minutes
    } = _dateUtils.default.correctTime(time.hours, time.minutes);
    date.setHours(hours);
    date.setMinutes(minutes);
    const updatedUnix = _dateUtils.default.dateToUnixtime(date);
    this.setState({
      time: {
        hours,
        minutes
      },
      unix: updatedUnix,
      isUpdating: false
    });
    onTimeChange({
      id,
      unix: updatedUnix
    });
  }
  handleInputChangeTime({
    id,
    value
  }) {
    const regexTwoDigitNumber = /^\d{0,2}$/;
    if (!regexTwoDigitNumber.test(value)) return;
    const {
      time
    } = this.state;
    const {
      updateOnInputChange
    } = this.props;
    const newTime = _objectSpread(_objectSpread({}, time), {}, {
      [id]: value
    });
    this.setState({
      time: newTime,
      isUpdating: true
    }, () => {
      if (updateOnInputChange) {
        this.updateTimeDebounced();
      }
    });
  }
  renderTimeInput(id) {
    const {
      time
    } = this.state;
    const {
      updateOnInputChange
    } = this.props;
    let tab = 0;
    if (this.props.id === 'startDate') {
      tab = id === 'hours' ? 1 : 2;
    } else tab = id === 'hours' ? 3 : 4;
    return /*#__PURE__*/_react.default.createElement("input", {
      tabIndex: tab,
      value: time[id],
      onFocus: e => e.target.select(),
      onBlur: !updateOnInputChange ? this.handleBlurTime : undefined,
      onChange: e => this.handleInputChangeTime({
        id,
        value: e.target.value
      }),
      onKeyDown: this.handleKeyDown,
      maxLength: 2
    });
  }
  handleInputChangeDate(e) {
    const dateValue = e.target.value;
    this.setState({
      dateValue
    }, () => {
      if (this.props.updateOnInputChange) {
        this.parseDateEntryDebounced(dateValue);
      }
    });
  }
  renderDateInput() {
    const {
      dateValue
    } = this.state;
    const {
      isoDays,
      updateOnInputChange
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("input", {
      placeholder: isoDays ? 'DD.MM.YYYY' : 'MM/DD/YYYY',
      value: dateValue,
      autoFocus: true,
      onBlur: !updateOnInputChange ? this.handleBlurDate : undefined,
      onChange: this.handleInputChangeDate,
      onKeyDown: this.handleKeyDown
    });
  }
  parseDateEntry(dateValue) {
    let date = dateValue;
    const {
      isoDays,
      onDateChange
    } = this.props;
    // convert to U.S. date format (begins with the month)
    const regex = /^\d{1,2}(-|\/|\.)\d{1,2}(-|\/|\.)\d{2,4}/;
    if (isoDays && regex.test(dateValue)) {
      const tmp = dateValue.split(/-|\/|\./);
      date = `${tmp[1]}/${tmp[0]}/${tmp[2]}`;
    }
    const unix = Date.parse(date) / 1000;
    if (isNaN(unix)) {
      this.setState({
        dateError: true
      });
      return;
    }
    this.setState({
      activeDateInput: false,
      dateError: false,
      dateValue: ''
    });
    const {
      day,
      month,
      year
    } = _dateUtils.default.unixtime2Date(unix);
    onDateChange({
      day,
      month: month + 1,
      year
    });
  }
  render() {
    const {
      displayTime,
      activeDateInput,
      dateError
    } = this.state;
    const {
      classes,
      timeError,
      size,
      unix,
      rangeError
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.dateTimeRow, classes[size])
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.dateContainer, {
        displayTime
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.dateValue, {
        error: !!dateError || !!rangeError
      }),
      onClick: () => this.setState({
        activeDateInput: true
      })
    }, activeDateInput ? this.renderDateInput() : /*#__PURE__*/_react.default.createElement("span", null, unix ? _dateUtils.default.toDate(unix, 'DD m YYYY') : ''))), displayTime ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.timeContainer)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.timeValue, {
        error: !!timeError
      })
    }, this.renderTimeInput('hours')), /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.timeSeparator),
      value: ":"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.timeValue, {
        error: !!timeError
      })
    }, this.renderTimeInput('minutes'))) : null);
  }
}) || _class);
DateTimeHeader.defaultProps = {
  size: 'medium',
  displayTime: false,
  updateOnInputChange: false,
  onTimeChange: () => {},
  onDateChange: () => {}
};
var _default = exports.default = DateTimeHeader;